import React from 'react';
import {connect} from 'dva';
import {framework_tool, component_tool} from '@/tool'
import {templateConfig, reduxTemplateConfig} from './config'

const {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
let {WizBrowserExport} = component_tool;

class SyncRelationPositionManager extends WizContainer {
  componentName = 'syncRelationManage';

  constructor(props) {
    super(props);
    this.state = {
      AddTimestamp: new Date().getTime()
    }
  }

  _render() {
    let _templateConfig = templateConfig(this)
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        export:this._handleFile,
      },
    });
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key];
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '来源',
        field: 'channel',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '关联类型',
        field: 'dataType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '第三方岗位编码',
        field: 'thirdId',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '岗位名称',
        field: 'positionName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '岗位编码',
        field: 'positionCode',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '所属组织',
        field: 'positionOrgListStr',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      if(data && data instanceof Array && data.length>0){
        let channelEnum = {'Zk': '企业号'}
        let dataTypeEnum = {'SyncPosition': '普通岗位', 'SyncNewEnergyPosition': '新能源岗位'}
        data.forEach(p=>{
          p['channel'] = p['channel'] && channelEnum[p['channel']]
          p['dataType'] = p['dataType'] && dataTypeEnum[p['dataType']]
          p['positionOrgListStr'] = p['positionOrgList'].map(item => item.name).join(",")
        })
      }

      WizBrowserExport({
        title: '岗位关联关系',
        sheetName: '岗位关联关系',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '岗位关联关系.xlsx',
      })

      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const {syncRelation} = state;

  const list = modelUtils.getLoadingState(syncRelation, ['list']);

  return {
    list
  }
};

export default connect(mapStateToProps)(SyncRelationPositionManager);
